// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__3OAHy","large":"modal_large__3_wrW","normal":"modal_normal__1NjkV"};